module.exports = __webpack_public_path__ + "static/LOGO 9-8e436ecc98e6def01ff363607cec3643.png";